import { render, staticRenderFns } from "./StatisticCardHorizontalReverse.vue?vue&type=template&id=0ae76c62&"
import script from "./StatisticCardHorizontalReverse.vue?vue&type=script&lang=js&"
export * from "./StatisticCardHorizontalReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports